import {
    NivalizTransactionVolumeBySlotDimensionDonutChart as NivalizTransactionVolumeBySlotDimensionDonutChartRenderer,
    hasChartSeries
} from '@frontend/chart/components';
import { NivalizTransactionVolumeBySlotDimensionDonutChart } from '@frontend/chart/components';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import { InsightCardWidth } from '../insight-card-width';
import { InsightCard } from '../insight-card/insight-card.component';
import { useInsightChartMinHeight } from '../insight-detail-mode.context';
import { InsightId } from '../insight-registry/insight-ids';
import { useNivalizCompartmentUsageBySizeDonutChart } from './use-nivaliz-compartment-usage-by-size-donut-chart';

export interface NivalizCompartmentUsageBySizeDonutChartProps {
    accountId: string;
    width?: InsightCardWidth;
}

export const NivalizCompartmentUsageBySizeDonutChart = ({ accountId, width }: NivalizCompartmentUsageBySizeDonutChartProps) => {
    const chartMinHeight = useInsightChartMinHeight(280);
    const { data, isLoading } = useNivalizCompartmentUsageBySizeDonutChart(accountId);

    return (
        <InsightCard
            insightId={InsightId.NIVALIZ_COMPARTMENT_USAGE_BY_SIZE}
            chartKey={NivalizTransactionVolumeBySlotDimensionDonutChart.definition.key}
            width={width}
            title={
                <FormattedMessage
                    id='platform.analytics.insights.nivaliz-compartment-usage-by-size-donut-chart.slot-usage-title'
                    description='Title for the Nivaliz SLOT usage-by-size donut chart on analytics insights'
                    defaultMessage='SLOT usage by size'
                />
            }
            subtitle={
                <FormattedMessage
                    id='platform.analytics.insights.nivaliz-compartment-usage-by-size-donut-chart.subtitle'
                    description='Subtitle indicating compartment usage by size covers the last 30 days of Nivaliz transaction volume grouped by SLOT dimension'
                    defaultMessage='last 30 days'
                />
            }
            isLoading={isLoading}>
            {!hasChartSeries(data) || !data ? (
                <div className='text-foreground-default'>{CommonMessage.ERRORS.NO_DATA_AVAILABLE}</div>
            ) : (
                <div className='w-full min-w-0'>
                    <NivalizTransactionVolumeBySlotDimensionDonutChartRenderer
                        data={data}
                        showSliceValues
                        minHeight={chartMinHeight}
                    />
                </div>
            )}
        </InsightCard>
    );
};
